import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { updateAppeal } from "../../../../api/postCall/updateAppeal";
import { CaseAppealsTableRowData } from "../../../../data-model/caseAppealsTable";
import { logError } from "../../../../utils/customLogger";
import { AppealInfoFormData } from "../utils/buildAppealInfoInitialData";
import { buildUpdateAppealPayload } from "../utils/buildUpdateAppealPayload";

interface OnAppealInfoSaveParams {
  data: CaseAppealsTableRowData;
  appealInfo: AppealInfoFormData;
  onSuccess: () => void;
  onError: (error: Error) => void;
}

/**
 * Persists Appeal Info fields for a case appeals row via `pharmacy/appeal/update`.
 *
 * @param params - Row data, form values, and success/error callbacks
 */
export const onAppealInfoSave = async (params: OnAppealInfoSaveParams) => {
  const { data, appealInfo, onSuccess, onError } = params;

  try {
    if (!data.identifier) {
      throw new Error("Identifier not found in data");
    }

    const payload = buildUpdateAppealPayload(data, appealInfo);
    await updateAppeal(payload);

    toast.success("Appeal info updated successfully");
    onSuccess();
  } catch (error) {
    logError(error as Error, "onAppealInfoSave");
    onError(error as Error);
  }
};
